export const [
  PREVENTION_HANDOFF_CREATE_REQUEST,
  PREVENTION_HANDOFF_CREATE_SUCCESS,
  PREVENTION_HANDOFF_FAILURE,
  PREVENTION_HANDOFF_STATUS_REQUEST,
  PREVENTION_HANDOFF_STATUS_SUCCESS,
  PREVENTION_HANDOFF_SMS_REQUEST,
  PREVENTION_HANDOFF_CANCEL_REQUEST,
  RESET_PREVENTION_HANDOFF,
] = [
  "PREVENTION_HANDOFF_CREATE_REQUEST",
  "PREVENTION_HANDOFF_CREATE_SUCCESS",
  "PREVENTION_HANDOFF_FAILURE",
  "PREVENTION_HANDOFF_STATUS_REQUEST",
  "PREVENTION_HANDOFF_STATUS_SUCCESS",
  "PREVENTION_HANDOFF_SMS_REQUEST",
  "PREVENTION_HANDOFF_CANCEL_REQUEST",
  "RESET_PREVENTION_HANDOFF",
]

// Statuses returned by the API (`expired` is computed server-side)
export const HANDOFF_PENDING = "pending"
export const HANDOFF_OPENED = "opened"
export const HANDOFF_EXPIRED = "expired"
export const HANDOFF_CANCELLED = "cancelled"
export const HANDOFF_COMPLETED = "completed"

export const HANDOFF_POLL_INTERVAL_MS = 5000
